import { CheckCircle2, Target, Heart, Award } from "lucide-react";

export default function Sobre() {
  return (
    <div data-testid="sobre-page" className="pb-24">
      {/* Hero */}
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1505624198937-c704aff72608?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwY293b3JraW5nJTIwc3BhY2V8ZW58MHx8fHwxNzc4NTc1Mzk2fDA&ixlib=rb-4.1.0&q=85"
            alt="VM Corporate"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#0A1128]/85" />
        </div>
        <div className="relative max-w-5xl mx-auto px-6 lg:px-12 text-center">
          <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-semibold mb-4">Sobre Nós</div>
          <h1 className="font-display text-5xl lg:text-6xl text-white font-light leading-tight">
            Mais que um escritório.
            <span className="block italic text-[#D4AF37] mt-2">Uma comunidade corporativa.</span>
          </h1>
          <p className="text-lg text-white/70 mt-8 max-w-3xl mx-auto">
            VM Corporate nasceu em Piabetá, Magé, para oferecer à região metropolitana do Rio de Janeiro
            um coworking de padrão internacional — premium, sofisticado e pensado para quem busca excelência.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="bg-[#0A1128] py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-12 grid md:grid-cols-2 gap-16">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-semibold mb-4">Nossa história</div>
            <h2 className="font-display text-4xl text-white font-light mb-6">Construído por empreendedores, para empreendedores.</h2>
            <div className="space-y-4 text-white/70 leading-relaxed">
              <p>O VM Corporate surgiu da percepção de que profissionais e empresas em Magé e região mereciam um espaço corporativo à altura de suas ambições — sem precisar se deslocar para o centro do Rio.</p>
              <p>Combinamos arquitetura sofisticada, tecnologia de ponta e atendimento personalizado para criar um ambiente que inspira produtividade e fortalece negócios.</p>
              <p>Nossa missão é simples: ser o melhor coworking do Brasil para quem entende que o ambiente molda os resultados.</p>
            </div>
          </div>
          <div className="space-y-5">
            {[
              { icon: Target, title: "Missão", text: "Oferecer infraestrutura corporativa premium para impulsionar negócios e carreiras." },
              { icon: Heart, title: "Visão", text: "Ser o coworking referência em sofisticação e qualidade no Estado do Rio de Janeiro." },
              { icon: Award, title: "Valores", text: "Excelência, comunidade, inovação e respeito a cada profissional que passa por aqui." },
            ].map((v) => (
              <div key={v.title} className="card-marketing p-6 flex gap-4">
                <div className="w-11 h-11 rounded-md bg-[#D4AF37]/10 border border-[#D4AF37]/30 flex items-center justify-center flex-shrink-0">
                  <v.icon size={18} className="text-[#D4AF37]" />
                </div>
                <div>
                  <div className="font-display text-white text-lg mb-1">{v.title}</div>
                  <div className="text-sm text-white/60">{v.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Differentials */}
      <section className="bg-[#0A1128] py-20 border-t border-white/5">
        <div className="max-w-6xl mx-auto px-6 lg:px-12">
          <h2 className="font-display text-4xl text-white font-light text-center mb-12">Por que o <span className="italic text-[#D4AF37]">VM Corporate</span>?</h2>
          <div className="grid md:grid-cols-2 gap-x-12 gap-y-4">
            {[
              "Endereço corporativo premium em Magé/RJ",
              "Salas equipadas com tecnologia de ponta",
              "Internet dedicada e fibra ótica redundante",
              "Atendimento de recepção profissional",
              "Estacionamento fácil nas proximidades",
              "Café especial e copa equipada",
              "Funcionamento de segunda a sábado",
              "Networking com empresas e profissionais da região",
            ].map((item) => (
              <div key={item} className="flex items-center gap-3 py-3 border-b border-white/5">
                <CheckCircle2 size={18} className="text-[#D4AF37]" />
                <span className="text-white/80">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
